import MuiSwitch, { SwitchProps } from "@mui/material/Switch";

const Checkbox: React.FC<SwitchProps> = MuiSwitch;

export default Checkbox;

export type { SwitchProps };
